import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_PRODUCT = "listProducts";
export const GET_DETAIL_PRODUCT = "detailProducts";
export const SAVE_PRODUCT = "saveProducts";
export const UPDATE_PRODUCT = "updateProducts";
export const DELETE_PRODUCT = "deleteProducts";
export const UPLOAD_PRODUCT_IMAGE = "uploadProduct";
export const SET_LIST_PRODUCT = "setListProduct";
// export const SET_LIST_TAG = "setListTag";
export const SET_DETAIL_PRODUCT = "setDetailProduct";

export const SET_LIST_PRODUCT_SEARCH = "setListProductSearch";
export const GET_LIST_PRODUCT_SEARCH = "getListProductSearch";
export const UPDATE_ORDER_PRODUCT = "updateOrderProduct";


const state = {
    productions: [],
    production: {},
    productionSearches :[],
};

const getters = {
    productions(state) {
        return state.productions;
    },
    production(state) {
        return state.production;
    },
    productionSearches(state){
        return state.productionSearches;
    }
};

const actions = {
    [GET_LIST_PRODUCT](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PRODUCT).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PRODUCT, data);
                    context.commit(SET_LIST_PRODUCT_SEARCH, data.data)
                }
                resolve(data);
            });
        });
    },
    [GET_LIST_PRODUCT_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_PRODUCT_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_PRODUCT_SEARCH, data.data.products);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_PRODUCT](context, id) {
        return new Promise(resolve => {
            ApiService.query(`${API.GET_DETAIL_PRODUCT}/${id}`).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DETAIL_PRODUCT, data);
                }
                resolve(data);
            });
        });
    },
    [UPLOAD_PRODUCT_IMAGE](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_PRODUCT_IMAGE}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [SAVE_PRODUCT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_PRODUCT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_PRODUCT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_PRODUCT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_PRODUCT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_PRODUCT}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_ORDER_PRODUCT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.put(`${API.UPDATE_ORDER_PRODUCT}/${payload.id}/order`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
};

const mutations = {
    [SET_LIST_PRODUCT](state, data) {
        state.productions = data.data;
    },
    [SET_DETAIL_PRODUCT](state, data) {
        state.production = data.data;
    },
    // [SET_LIST_TAG](state, data) {
    //     state.tags = data.data;
    // },
    [SET_LIST_PRODUCT_SEARCH](state, data){
        state.productionSearches =  data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};